import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { ContractSignerType } from './contractSignerApiTypes';

export const getUserContractSigners = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<ContractSignerType>>(
        config,
        'contractsigner?filtered=true',
        'GET',
        null,
        commonHeaders,
    );

export const getContractSigners = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<ContractSignerType>>(config, 'contractsigner', 'GET', null, commonHeaders);

export const createContractSigner = async (
    config: LoruleRequestConfig,
    contractSigner: ContractSignerType,
) => callWebUtils(config, `/contractsigner`, 'POST', JSON.stringify(contractSigner), commonHeaders);

export const updateContractSigner = async (
    config: LoruleRequestConfig,
    contractSigner: ContractSignerType,
) =>
    callWebUtils(
        config,
        `/contractsigner/${contractSigner.signerId}`,
        'PUT',
        JSON.stringify(contractSigner),
        commonHeaders,
    );

export const deleteContractSigner = async (config: LoruleRequestConfig, signerId: number) =>
    callWebUtils(config, `/contractsigner/${signerId}`, 'DELETE', null, commonHeaders);
